var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-editor"},[_c('div',{staticStyle:{"display":"none"}},[_vm._v("\n    "+_vm._s(_vm.search)+"\n  ")]),_c('div',{ref:"editor",staticStyle:{"height":"100vh"}})])}
var staticRenderFns = []

export { render, staticRenderFns }